import { IAPPROPOSALSTATUS, StateModel, StepStateType } from 'bff';
import { StepConfig, StepperCategoryState } from 'types/stepper/proposal-stepper-type';

export const mapStepStateToStepper = (stepState: StepStateType): StepperCategoryState => {
  switch (stepState) {
    case StepStateType.Default:
      return StepperCategoryState.DEFAULT;
    case StepStateType.Invalid:
      return StepperCategoryState.ERROR;
    case StepStateType.Complete:
      return StepperCategoryState.COMPLETED;
    default:
      return StepperCategoryState.DEFAULT;
  }
};

export const getStepConfig = (
  formState: StateModel,
  isCloned: boolean,
  proposalStatus?: IAPPROPOSALSTATUS,
  overrideStepper?: boolean
): StepConfig[] => [
  {
    step: 1,
    title: 'Client details',
    state: mapStepStateToStepper(formState.step1)
  },
  {
    step: 2,
    title: 'Product selection',
    state: mapStepStateToStepper(formState.step2)
  },
  {
    step: 3,
    title: 'Investment details',
    state: mapStepStateToStepper(formState.step3)
  },
  {
    step: 4,
    title: 'Proposal summary',
    state: mapStepStateToStepper(formState.step4)
  },
  {
    step: 5,
    title: 'Application',
    state: mapStepStateToStepper(formState.step5),
    customIsDisabled:
      !overrideStepper && proposalStatus === IAPPROPOSALSTATUS.ProposalInProgress && !isCloned
  },
  {
    step: 6,
    title: 'Signing',
    state: mapStepStateToStepper(formState.step6)
  }
];
